import { render, staticRenderFns } from "./BannerMobile.vue?vue&type=template&id=715fe629&scoped=true&name=Banner&"
import script from "./BannerMobile.vue?vue&type=script&lang=js&"
export * from "./BannerMobile.vue?vue&type=script&lang=js&"
import style0 from "./BannerMobile.vue?vue&type=style&index=0&id=715fe629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715fe629",
  null
  
)

/* custom blocks */
import block0 from "./BannerMobile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports